import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { citizenService } from '../../services/central-api/citizen';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    showLabel?: boolean;
}

function CitizenDropdown({ value, setValue, zIndex, showLabel }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filterTimeout, setFilterTimeout] = useState<NodeJS.Timeout>();
    const [citizenText, setCitizenText] = useState<string>();

    async function getItems(citizenText: string) {
        try {
            setIsLoading(true);
            const citizen = await citizenService.getSimplifiedCitizen(citizenText);
            setItems(citizen.map((citizen) => {
                return {
                    value: citizen.id,
                    label: `${citizen.document} - ${citizen.name}`
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (citizenText && citizenText.length > 2) {
            getItems(citizenText);
        }
    }, [citizenText]);

    return (
        <FilterDropdown
            label={showLabel ? translate('citizen') : ''}
            placeholder={translate('typeToSearch')}
            items={items}
            multiple={true}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            mode='BADGE'
            searchable={false}
            disableLocalSearch={true}
            loading={isLoading}
            onChangeSearchText={(text) => {
                if (text && text?.length > 2) {
                    if (filterTimeout) {
                        clearTimeout(filterTimeout);
                    }

                    const timeout = setTimeout(() => {
                        setCitizenText(text);
                    }, 1000);

                    setFilterTimeout(timeout);
                }
            }}
        />
    );
}

export default CitizenDropdown;
